module.exports = __webpack_public_path__ + "static/media/newsletter-december-2021-christmas.f419f48b.jpg";